<md-dialog>
	@if (loading()) {
		<lb-loader message="Loading grades..."></lb-loader>
	} @else if (error(); as errorMsg) {
		<md-content-box type="error">{{ errorMsg }}</md-content-box>
	} @else {
		<div class="review">
			<md-header size="sm">Review & Submit Grades</md-header>

			<md-content-box type="info">
				By submitting, you confirm that you have reviewed the semester grades for this learner and that they are accurate to the best of your knowledge.
				You understand that submitting these grades will finalize them in the system. You cannot make changes to the grades after submission without
				contacting support.
			</md-content-box>

			<div class="review-list">
				@for (item of reviewItems(); track item.categoryName; let isFirst = $first) {
					<md-content-box class="review-row" type="default">
						<div class="review-row__info">
							<span class="review-row__name">{{ item.categoryName }}</span>
							<md-tag type="tertiary">{{ item.weightPercent }}%</md-tag>
						</div>
						<div class="review-row__value">
							@if (item.isProjectGrade) {
								<md-drop-down
									[options]="overrideGradeOptions()"
									[value]="item.overrideGradeID"
									placeholder="A+ / F"
									[dense]="true"
									(change)="onProjectOverrideChanged($event, item.categoryID)"
								></md-drop-down>
							}
							<lb-grade-tag [grade]="item.gradeName" [type]="item.gradeColor"></lb-grade-tag>
						</div>
					</md-content-box>
				} @empty {
					<p class="no-data">No grades to review.</p>
				}

				@if (semesterFinalGrade(); as finalGrade) {
					<md-content-box class="review-row" type="success">
						<span class="review-row__label">Semester Final Grade</span>
						<div class="review-row__value">
							<md-drop-down
								[options]="overrideGradeOptions()"
								[value]="semesterOverrideGradeID()"
								placeholder="A+ / F"
								[dense]="true"
								(change)="onFinalGradeOverrideChanged($event)"
							></md-drop-down>
							<lb-grade-tag [grade]="finalGrade.gradeName" [type]="finalGrade.color"></lb-grade-tag>
						</div>
					</md-content-box>
				}
			</div>

			<div class="actions">
				<button md-button (click)="onCancel()">Cancel</button>
				<button md-button-brand [disabled]="reviewItems().length === 0 || saving()" (click)="onSubmit()">
					@if (saving()) {
						Saving...
					} @else {
						Submit Grades
					}
				</button>
			</div>
		</div>
	}
</md-dialog>
